<script lang="ts">
  import { _ } from 'svelte-i18n';
  import GroupCommunityIcon from './GroupCommunityIcon.svelte';
  import { getRequest } from './Util/utils';
  import route  from './Util/routes';
  import { utcToZonedTime } from 'date-fns-tz';
  import { date, time } from 'svelte-i18n';

  export let group_communities = [];
  export let community_items = [];
  export let joined_club = null;
  export let has_joined_club = null;
  export let onChange = ()=>{};
  export let onClose = ()=>{};
  export let onComplete = ()=>{};
  export let onDeselect = ()=>{};
  export let waiting = false;

  let request: RequestInit = getRequest()

  export function submit(){
    if (waiting){
      return
    };
    waiting = true;
    return window.fetch(route('SessionsController@postManageCommunities'), {
      ...request,
      method: 'POST',
      body: JSON.stringify({
        leave: group_communities.filter(c=>c.joined).map(c=>c.name),
        join: community_items.filter(c=>c.joined).map(c=>c.name),
        sessions: []
      }),
    }).finally(()=>{
      onClose();
      onChange();
      waiting = false;
    });
  };
  export function doLeave(){
    community_items.forEach(c=>c.joined = false);
    if (waiting) return;
    waiting = true;
    return window.fetch(route('SessionsController@postLeaveCommunities'), {
      ...request,
      method: 'POST',
    }).finally(()=>{
      onClose();
      onChange();
      waiting = false;
    });
  }


  $: community_items = group_communities.map(c=> { return {...c}});
  $: joined_club = community_items.find(c=>c.joined);

  $: has_joined_club = group_communities.find(c=>c.joined);

  $: sessions = joined_club != null ? joined_club.sessions : [];
  let times = [];
  let days = [];
  $: {
    // Collect unique time-of-day values from all sessions.
    let tz = -(new Date().getTimezoneOffset() * 60.0); // timezone offset seconds.
    let minute = 60;
    let hour = 3600;

    let lz = (v)=> ('0'+v).slice(-2);
    let t = tz < 0 ? -tz : tz;
    let minutes = lz(Math.floor(t/minute) % minute);
    let hours = lz(Math.floor(t/hour));
    let sign = tz < 0 ? "-" : "+"; 
    let tz_string = `${sign}${hours}:${minutes}`;

    let ts = new Map();
    let ds = new Set();
    sessions.forEach(s=> {
      const date_obj = new Date(s.start_date);
      const zoned_time = utcToZonedTime(s.start_date, tz_string);
      const fmt = $time(zoned_time);
      //const joined = (ts.get(fmt)?.joined ?? false) || s.joined;
      const time_obj = {fmt: fmt, h: date_obj.getUTCHours(), m: date_obj.getUTCMinutes()};
      if (time_obj.m == 0) {
        // Only use sessions that are on the hour (no minutes)
        ts.set(fmt, time_obj);
        const day = $date(zoned_time, {weekday: "long"});
        ds.add(day);
      }
    });
    times = Array.from(ts.values());
    days = Array.from(ds);
  }

  function onClubClicked(index, id, name, display_name) {
    if (waiting) return;

    if (!community_items[index].joined) {
      waiting = true;
      community_items.forEach(c => {
        c.joined = false;
      });
      community_items[index].joined = true;
      onComplete();
      setTimeout(()=>{
        waiting = false;
      }, 400);
    } else {
      community_items[index].joined = false;
      onDeselect();
    }
  }
</script>

<h1 class="w400 center">
{$_("sessions.group_picker.title")}
</h1>
<div class="medium center">
  {$_("sessions.group_picker.description")}
</div>

{#if community_items.length == 0}
  <div style="display: flex; justify-content: center; padding-top: 48px;">
    <div style="color: var(--color-xert-teal); font-size: 32px; flex: 0 0 0;" class="fas fa-circle-notch fa-spin"/>
  </div>
{/if}
<grid style={'grid-template-columns: repeat(2, minmax(0, 1fr));'} class:waiting class="communities">
{#each community_items as {id, name, display_name, joined, member_count}, index}
  <button class:joined on:click = {()=>onClubClicked(index, id, name, display_name)} >
    <GroupCommunityIcon name={name} member_count={member_count}/>
  </button>
{/each}
</grid>

<style lang="scss">
  @import './style/xert.scss';
  h4.w500 {
    font-size: 20px;
  }
  h1.w400 {
    margin-bottom: 24px;
  }
  .medium {
    @include medium-text;
    margin-bottom: 24px;
  }
  .center {
    text-align: center;
  }
  grid {
    display: grid;
    grid-gap: 16px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    padding: 16px calc(50% - 250px);

    &.waiting {
      opacity: 50%;
    }

    > button {
      @include medium-text;
      color: #2F7076;
      aspect-ratio: 1;
      background: rgba(47, 112, 118, 0.2);
      border: unset;
      border-radius: 4px !important; // !important to override bootstrap theme. 

      &.joined {
        border: 2px solid #2F7076;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: end;
  }
  .footer > button {
    @include medium-text;
    height: 40px;
    padding: 10px;
    min-width: 104px;
    color: white;
    border: unset !important;
    background: #2F7076;
    border-radius: 4px !important;
  }

</style>